import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VTooltip,{attrs:{"left":"","disabled":!_vm.showTooltip},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c(VIcon,_vm._g({attrs:{"small":"","color":_vm.color}},on),[_vm._v(" $freshvuenotes-severity-"+_vm._s(_vm.severity)+" ")])]}}])},[_c('span',[_vm._v(" "+_vm._s(_vm.$t('fresh-vue-notes.fields.severity'))+": "+_vm._s(_vm.$t(`fresh-vue-notes.severity.${_vm.severity}`))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }